import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { qrScannerApi, type ScannedAttendeeItem } from "../qrScanner.api";

export const useScannerCheckInByQrCode = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const execute = useCallback(
    async (eventId: string, qrToken: string): Promise<ScannedAttendeeItem> => {
      setIsLoading(true);
      setError(null);
      try {
        return await qrScannerApi.checkInByQrCode(eventId, qrToken);
      } catch (requestError: unknown) {
        const message = getApiErrorMessage(requestError, "Failed to check in. Please try again.");
        setError(message);
        throw new Error(message);
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  return { execute, error, isLoading };
};
